import { render, staticRenderFns } from "./Customize.vue?vue&type=template&id=d3fe544a"
import script from "./Customize.vue?vue&type=script&lang=js"
export * from "./Customize.vue?vue&type=script&lang=js"
import style0 from "./Customize.vue?vue&type=style&index=0&id=d3fe544a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports